var rtl_default = {
  "rtl": "JN5E8",
  "ltr": "R3MdH"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
